/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Use_1_ValueInputs */

const en_svc_agents_use_1_value = /** @type {(inputs: Svc_Agents_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new enquiry gets a researched, drafted follow-up within minutes, waiting for the owner to send it.`)
};

const lv_svc_agents_use_1_value = /** @type {(inputs: Svc_Agents_Use_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jauns pieprasījums dažu minūšu laikā saņem sagatavotu atbildi, kas gaida, kad pārdevējs to nosūtīs.`)
};

/**
* | output |
* | --- |
* | "A new enquiry gets a researched, drafted follow-up within minutes, waiting for the owner to send it." |
*
* @param {Svc_Agents_Use_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_use_1_value = /** @type {((inputs?: Svc_Agents_Use_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Use_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_use_1_value(inputs)
	return en_svc_agents_use_1_value(inputs)
});